/*
 * @Author: bianbinbin
 * @Date: 2024-11-07 10:18:37
 * @LastEditors: bianbinbin
 * @LastEditTime: 2025-12-05 14:33:50
 * @PageTitle: 页面...
 * @Description: 描述...
 * @FilePath: /ejx-web/src/router/module/recentRiskWarning.js
 */

const recentRiskWarning = r =>
  require.ensure([], () => r(require('@/views/recentRiskWarning/recentRiskWarning.vue'), 'recentRiskWarning'))
const recentRiskWarningDetail = r => require.ensure([], () => r(require('@/views/recentRiskWarning/recentRiskWarningDetail.vue'), 'recentRiskWarningDetail'))

const router = [
  {
    path: '/recentRiskWarning',
    name: 'recentRiskWarning',
    meta: {
      title: '近期风险预警'
    },
    component: recentRiskWarning
  },
  {
    path: '/recentRiskWarningDetail',
    name: 'recentRiskWarningDetail',
    meta: {
      title: '近期风险预警详情'
    },
    component: recentRiskWarningDetail
  },
]

export default router
